// extracted by mini-css-extract-plugin
export default {"tabs":"tabs--FRL_O","tab":"tab--aRi7Z"};